import { useEffect } from "react";

import BottonSheet from "src/components/ui/BottonSheet";
import Modal from "./Modal";
import AddOther from "./AddOther";

import useDeviceSize from "src/hooks/useDeviceSize";

const ProductSheet = ({ docType, isOpen, onClose, onAppendData }) => {
  const [deviceWidth] = useDeviceSize();

  useEffect(() => {
    if (deviceWidth > 835) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceWidth]);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      {deviceWidth > 835 ? (
        <Modal isOpen={isOpen} onClose={onClose} onSubmit={onAppendData} />
      ) : (
        <BottonSheet
          title={
            docType === "product"
              ? `เพิ่มสินค้า`
              : docType === "service"
                ? `เพิ่มรายละเอียดการบริการ`
                : `เพิ่มสินค้าใหม่`
          }
          onClose={handleClose}
          open={isOpen}
        >
          <AddOther onSubmit={onAppendData} onClose={handleClose} />
        </BottonSheet>
      )}
    </>
  );
};

export default ProductSheet;
